module.exports = __webpack_public_path__ + "img/arrow-right-double.4633b3f.svg";